import { Provider } from 'react-redux';
import { store } from './store';
import Router from './router';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './store';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div className="lk-spinner lk-spinner-lg" style={{ margin: '40vh auto' }} />} persistor={persistor}>
        <Router />
      </PersistGate>
    </Provider>
  );
}

export default App;
